import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader, CheckCircle, XCircle } from 'lucide-react';
import { verifyMarketplacePayment } from '../../services/marketplaceOrderService';

const MarketplaceConfirmPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');

  useEffect(() => {
    let isSubscribed = true;

    const verify = async () => {
      const reference = new URLSearchParams(location.search).get('reference');
      const orderId = localStorage.getItem('pendingMarketplaceOrderId');
      if (!reference || !orderId) {
        if (isSubscribed) setStatus('failed');
        return;
      }

      try {
        const result = await verifyMarketplacePayment(reference, orderId);
        if (isSubscribed) {
          if (result.status) {
            setStatus('success');
            localStorage.removeItem('pendingMarketplaceOrderId');
          } else {
            setStatus('failed');
          }
        }
      } catch (err) {
        if (isSubscribed) setStatus('failed');
      }
    };

    const timeout = setTimeout(verify, 100);
    return () => { isSubscribed = false; clearTimeout(timeout); };
  }, [location]);

  if (status === 'verifying') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <Loader className="w-12 h-12 animate-spin text-green-500 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Verifying payment</h2>
          <p className="text-gray-600">We're confirming your booking and finding you a therapist...</p>
        </div>
      </div>
    );
  }

  if (status === 'failed') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <XCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-red-600 mb-4">Payment verification failed</h2>
          <button onClick={() => navigate('/')} className="bg-green-500 text-white py-2.5 px-6 rounded-lg">
            Return to home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center max-w-md px-4">
        <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Booking confirmed!</h2>
        <p className="text-gray-600 mb-6">
          We're now matching you with an available therapist. You'll be notified once one is assigned.
        </p>
        <button onClick={() => navigate('/dashboard')} className="bg-black text-white py-2.5 px-6 rounded-lg">
          View my orders
        </button>
      </div>
    </div>
  );
};

export default MarketplaceConfirmPage;
